/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTicketStatus } from '../../models/api-response-ticket-status';

export interface GetStatusByRef$Params {
  ref: string;
}

export function getStatusByRef(http: HttpClient, rootUrl: string, params: GetStatusByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketStatus>> {
  const rb = new RequestBuilder(rootUrl, getStatusByRef.PATH, 'get');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTicketStatus>;
    })
  );
}

getStatusByRef.PATH = '/v1/api/ui/status-ticket/get/{ref}';
